module.exports = __webpack_public_path__ + "img/story045@2x.f45eb6a2.webp";